import type { SchemaBuilderGroupOptionItem } from "../schema-builder.type";
import type { GetOthersFieldsOptionsProps } from "./schema-builder-field.type";
import type { SchemaBuilderFieldType } from "../schema-builder-field-type";
import type { SchemaGroup } from "@/entities/schema";

import { getSchemaBuilderGroupOption } from "../schema-builder.helper";

export const getOthersFieldsOptions = ({
  currentField,
  formSchema,
  noGroupTxt,
}: GetOthersFieldsOptionsProps): SchemaBuilderGroupOptionItem[] => {
  const groups: SchemaGroup[] = [
    { legend: noGroupTxt, fields: formSchema.fields ?? [] },
    ...(formSchema.groups ?? []),
  ];

  const options = groups.map((group) =>
    getSchemaBuilderGroupOption({
      schemaGroup: group,
      excludedField: currentField,
      excludedType: "label",
    })
  );

  return options.filter((option) => option.options.length > 0);
};

export const filterOptionsByType = (
  groups: SchemaBuilderGroupOptionItem[],
  fieldType: SchemaBuilderFieldType
) => {
  return groups
    .map(({ options, ...group }) => ({
      ...group,
      options: options.filter((o) => o.type === fieldType),
    }))
    .filter((group) => group.options.length > 0);
};
